<div>
  <p>{{ news?.modified | date: ("common.dateTimeFormat" | translate) }}</p>
  <markdown [data]="news | news"></markdown>
</div>
